import React, {useState, useEffect} from 'react';
// Here we provide the initial value of the context
const AuthContext = React.createContext({});
export default AuthContext;
